import { render, staticRenderFns } from "./AbastecimentosDespesas.vue?vue&type=template&id=d112767a&scoped=true"
import script from "./AbastecimentosDespesas.vue?vue&type=script&lang=js"
export * from "./AbastecimentosDespesas.vue?vue&type=script&lang=js"
import style0 from "./AbastecimentosDespesas.vue?vue&type=style&index=0&id=d112767a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d112767a",
  null
  
)

export default component.exports